/* eslint-disable no-console */
import Head from 'next/head';
import type { AppProps } from 'next/app';

import { BackdropProvider } from '~/providers/backdrop';

import { GlobalStyle } from '~/styles/global';

function MyApp({ Component, pageProps }: AppProps): JSX.Element {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="description" content="Portal de controle de chamados" />

        <title>Painel de Chamados</title>
      </Head>

      <BackdropProvider>
        <GlobalStyle />
        <Component {...pageProps} />
      </BackdropProvider>
    </>
  );
}

export default MyApp;
